import { AskRovoIcon } from '@databases/database-ai-first-creation-ui/icons/ask-rovo-icon';
import { messages } from '@databases/intl/messages';
import React from 'react';

import { SELECT_VALUE_MENU_ACTIONS, type MenuItemBuilder } from '../types';
import { ElementBeforeIconWrapper } from '../ui/components';

export const askRovoMenuItem: MenuItemBuilder = ({
  capabilities: { canAskRovo },
  formatMessage,
}) => ({
  isEnabled: () => canAskRovo,
  menuItem: {
    key: SELECT_VALUE_MENU_ACTIONS.ASK_ROVO,
    content: formatMessage(messages['value-actions.ask-rovo']),
    onClick: () => {},
    closeOnClick: true,
    elemBefore: (
      <ElementBeforeIconWrapper>
        <AskRovoIcon height={16} width={16} />
      </ElementBeforeIconWrapper>
    ),
  },
});
